import styled from "styled-components";

export const ReportMapWrapper = styled.div`
  position: relative;
  height: 700px;
`;

export const ReportMapContainer = styled.div`
  .gm-style {
    font: 400 11px "Manrope", Arial, sans-serif;
  }
`;

export const ReportMapLoading = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(234, 236, 240, 0.9);
`;
